<img *ngIf="lang == 'nl'" id="flag" src="./public/flags/nl.svg" alt="nl vlag" (click)="switchLanguage('en')"/>
<img *ngIf="lang == 'en'" id="flag" src="./public/flags/en.svg" alt="en flag" (click)="switchLanguage('nl')"/>
